// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-card__wrapper{padding-top:138px!important;border-radius:10px}.category-card__name{max-width:150px}.category-card__total-jobs{width:110px;border:1px solid #fff;border-radius:20px}", ""]);
// Exports
module.exports = exports;
